import DateHelper from 'helpers/Date';

class Compare {
  ORDER_BY = {
    ASC: 'asc',
    DESC: 'desc'
  };
  DATA_TYPES = {
    DATE: 'DATE',
    NUMBER: 'NUMBER',
    TEXT: 'TEXT',
    BOOL: 'BOOL'
  };

  isOrderAscending(orderBy) {
    return orderBy === this.ORDER_BY.ASC;
  }

  compareInvalid(a, b, orderBy) {
    if (!a && b) {
      return this.isOrderAscending(orderBy) ? -1 : 1;
    } else if (a && !b) {
      return this.isOrderAscending(orderBy) ? 1 : -1;
    }
    return 0;
  }

  compareDate(a, b, orderBy) {
    const dateA = DateHelper.dateFormattedToDateObject(a);
    const dateB = DateHelper.dateFormattedToDateObject(b);

    return this.isOrderAscending(orderBy) ? dateA - dateB : dateB - dateA;
  }

  compareString(a, b, orderBy) {
    return this.isOrderAscending(orderBy)
      ? a.localeCompare(b)
      : b.localeCompare(a);
  }

  compareNumber(a, b, orderBy) {
    return this.isOrderAscending(orderBy) ? a - b : b - a;
  }

  compare(
    itemA = {},
    itemB = {},
    orderBy = this.ORDER_BY.ASC,
    type = this.DATA_TYPES.TEXT
  ) {
    if (!(itemA && itemB)) {
      return this.compareInvalid(itemA, itemB, orderBy);
    }

    switch (type) {
      case this.DATA_TYPES.TEXT: {
        return this.compareString(itemA, itemB, orderBy);
      }
      case this.DATA_TYPES.DATE: {
        return this.compareDate(itemA, itemB, orderBy);
      }
      default: {
        return this.compareNumber(itemA, itemB, orderBy);
      }
    }
  }
}

export default new Compare();
